import React from 'react';
import {createRoot} from "react-dom/client";
import App from './App';
import i18n from './i18n';
import {I18nextProvider, useTranslation} from 'react-i18next';
import "./Styles/index.css";
import "./Components/ui/ui.css";
import {ConfigProvider, App as AntdApp} from "antd";
import loc from "dayjs/locale/hr";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat'; // Import if you need to parse custom formats
import localizedFormat from 'dayjs/plugin/localizedFormat'; // Import for localized formatting
import utc from 'dayjs/plugin/utc'; // Import the UTC plugin
import weekday from 'dayjs/plugin/weekday'; // Import the weekday plugin
import {resolveAntdLocale} from "./i18n/antdLocale";
import {applyAtiCssVariables, atiTheme} from "./Theme/atiTheme";

dayjs.extend(customParseFormat); // Use this if you are parsing custom formats
dayjs.extend(localizedFormat); // Use this for localized formatting
dayjs.extend(utc); // Use the UTC plugin
dayjs.extend(relativeTime);
dayjs.extend(weekday);

dayjs.locale(loc);

applyAtiCssVariables();

const MainChildren = () => {
    const {i18n} = useTranslation();

    return <ConfigProvider theme={atiTheme} locale={resolveAntdLocale(i18n.language)}>
        <AntdApp style={{height: "100%"}}>
            <App/>
        </AntdApp>
    </ConfigProvider>;
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <MainChildren/>
        </I18nextProvider>
    </React.StrictMode>
);
